import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { AppNotificationUtilClass, Plani8DataService } from '@monorepo/services';
import { catchError, finalize, map, switchMap, take } from 'rxjs/operators';
import { TFactoryProductLineEfficiencyActionType } from './product-line-efficiency.models';
import * as FactoryProductLineEfficiencyActions from './product-line-efficiency.actions';
import { from, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FactoryProductLineEfficiencyEffects {
  constructor(
    private actions$: Actions,
    private plani8DataService: Plani8DataService,
    private appNotificationUtilClass: AppNotificationUtilClass,
  ) {}

  getFactoryProductLineEfficiency$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TFactoryProductLineEfficiencyActionType.GetFactoryProductLineEfficiency),
      switchMap((action: FactoryProductLineEfficiencyActions.GetFactoryProductLineEfficiency) =>
        from(this.appNotificationUtilClass.presentLoading()).pipe(
          take(1),
          map((loaderEl) => {
            return [loaderEl, action] as const;
          }),
        ),
      ),
      switchMap(([loaderEl, action]) =>
        this.plani8DataService.fetchFactoryProductLineEfficiency(action.factoryId, action.payload).pipe(
          finalize(() => {
            this.appNotificationUtilClass.dismissLoadingV2(loaderEl);
          }),
          map((res) => new FactoryProductLineEfficiencyActions.GetFactoryProductLineEfficiencySuccess(res)),
          catchError(() => of(new FactoryProductLineEfficiencyActions.GetFactoryProductLineEfficiencyFailure())),
        ),
      ),
    ),
  );

  deleteFactoryProductLineEfficiency$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TFactoryProductLineEfficiencyActionType.DeleteFactoryProductLineEfficiency),
      switchMap((action: FactoryProductLineEfficiencyActions.DeleteFactoryProductLineEfficiency) =>
        from(this.appNotificationUtilClass.presentLoading()).pipe(
          take(1),
          map((loaderEl) => {
            return [loaderEl, action] as const;
          }),
        ),
      ),
      switchMap(([loaderEl, action]) =>
        this.plani8DataService.deleteFactoryProductLineEfficiency(action.factoryId, action.deletePayload).pipe(
          finalize(() => {
            this.appNotificationUtilClass.dismissLoadingV2(loaderEl);
          }),
          map(
            (res) =>
              new FactoryProductLineEfficiencyActions.GetFactoryProductLineEfficiency(
                action.factoryId,
                action.fetchPayload,
              ),
          ),
          catchError(() => of(new FactoryProductLineEfficiencyActions.DeleteFactoryProductLineEfficiencyFailure())),
        ),
      ),
    ),
  );
}
